import gql from 'graphql-tag';

export const AccountProductsFragment = gql`
  fragment AccountProductsFragment on account_GlobalSet {
    bestsellersOn
    productsSliderHeading
    products: productSlider {
      typeHandle
      ... on products_Entry {
        shopifyHandle
      }
      ... on collections_Entry {
        collectionHandle
      }
    }
  }
`;
